import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import catalogueStructure from '../data/catalogueStructure';
import { labelForHamburger } from '../data/hamburgerOverrides';

function SubcatItems({ items, parentSlug, onClose }) {
  return (
    <div className="ml-2 mb-2 space-y-1">
      {items.map(function(sub) {
        return (
          <Link key={sub.slug} to={"/catalogue/" + parentSlug + "/" + sub.slug} onClick={onClose}
            className="flex items-center gap-2 py-2 pl-2 text-sm text-gray-700 hover:text-orange-600">
            <span className="text-base">{sub.emoji}</span>
            <span>{labelForHamburger(sub)}</span>
          </Link>
        );
      })}
    </div>
  );
}

function CategorySection({ cat, onClose }) {
  var [open, setOpen] = useState(false);
  var cls = "w-full flex items-center justify-between py-3 text-sm font-semibold " + (cat.highlight ? "text-orange-600" : "text-gray-800") + (open ? " text-orange-600" : "");
  var chevronCls = "w-4 h-4 text-gray-400 transition-transform " + (open ? "rotate-180" : "");

  return (
    <div className="border-b border-gray-50">
      <button onClick={function() { setOpen(!open); }} className={cls}>
        <span className="flex items-center gap-2">
          <span className="text-base">{cat.emoji}</span>
          <span>{cat.name}</span>
        </span>
        <ChevronDown className={chevronCls} />
      </button>
      {open && <SubcatItems items={cat.subcategories} parentSlug={cat.slug} onClose={onClose} />}
    </div>
  );
}

function MobileCatalogueMenu({ onClose }) {
  return (
    <div className="ml-4 mt-2 space-y-0 border-l-2 border-orange-200 pl-3" data-testid="mobile-catalogue-menu">
      <Link to="/catalogue" onClick={onClose} className="block py-2 text-sm text-gray-600 hover:text-orange-600">
        Tous les produits
      </Link>
      {catalogueStructure.map(function(cat) {
        return <CategorySection key={cat.slug} cat={cat} onClose={onClose} />;
      })}
    </div>
  );
}

export default MobileCatalogueMenu;
